import React, { Component } from "react";
import { generateGeneralLedger } from "../../services/reportService";

import BlockUi from "react-block-ui";
import { Message } from "semantic-ui-react";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactToPrint from "react-to-print";
import GeneralLedgerEntryPrintReport from "./print/generalledgerentry";

class GeneralLedgerReport extends Component {
  state = {
    transactions: [],
    showSalaryForm: false,
    showError: false,
    startDate: "",
    endDate: "",
    total: 0,
    totalDebit: 0,
    totalCredit: 0,
    closingTotalReceivable: 0,
    totalReceivable: 0,
    closingTotalIncome: 0,
    closingTotalExpense: 0,
    closingTotalNetAmount: 0,
    totalPayable: 0,
    totalIncome: 0,
    totalExpense: 0,
    netAmount: 0,
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  doSubmit = async () => {
    try {
      var event = new Date(this.state.startDate);
      event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      event.setDate(event.getDate() + 1);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const reportType = document.getElementById("report_type").value;

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
        report_type: reportType,
      };

      const { data: res } = await generateGeneralLedger(verifyData);

      //this.setState({ blocking: false, transactions: res.data,total: res.total });

      // const res = await generateRoomReport(verifyData);

      if (res.proceed === "no") {
        this.setState({
          showError: true,
          //showSalaryForm: false,
          blocking: false,
        });
      } else {
        this.setState({
          showError: false,
          //showSalaryForm: true,
          blocking: false,
          transactions: res.data,
          totalCredit: res.totalCredit,
          totalDebit: res.totalDebit,
          closingTotalReceivable: res.stats.closingTotalReceivable,
          closingTotalIncome: res.stats.closingTotalIncome,
          closingTotalExpense: res.stats.closingTotalExpense,
          closingTotalNetAmount: res.stats.closingTotalNetAmount,
          totalReceivable: res.stats.totalReceivable,
          totalPayable: res.stats.totalPayable,
          totalIncome: res.stats.totalIncome,
          totalExpense: res.stats.totalExpense,
          netAmount: res.stats.netAmount,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  doReset = () => {
    this.setState({ startDate: "", endDate: "" });
    this.reportInitialLoading();
  };

  async reportInitialLoading() {
    this.setState({ blocking: true });
    const { data: records } = await generateGeneralLedger();

    this.setState({
      blocking: false,
      transactions: records.data,
      showError: false,
      totalDebit: records.totalDebit,
      totalCredit: records.totalCredit,
    });
  }

  componentDidMount() {
    this.reportInitialLoading();
  }

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const {
      transactions,
      totalCredit,
      totalDebit,
      closingTotalReceivable,
      closingTotalIncome,
      closingTotalExpense,
      closingTotalNetAmount,
      totalReceivable,
      totalPayable,
      totalIncome,
      totalExpense,
      netAmount,
    } = this.state;

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">General Ledger</h1>

        <div className="grid receiveable-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            placeholderText="Select Start Date"
            className="input"
          />
          <div></div>
          <DatePicker
            selected={this.state.endDate}
            onChange={this.handleChangeEndDate}
            className="input"
            placeholderText="Select End Date"
          />
          <div></div>
          <select name="report_type" id="report_type" className="input">
            <option value="">Select rerport type</option>
            <option value="jv">JV</option>
            <option value="scrap">SCRAP</option>
          </select>
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
          <button className="btn btn--secondary" onClick={this.doReset}>
            Reset
          </button>
        </div>

        <center>
          <div className="ui error form" style={{ width: "30%" }}>
            <Message
              negative
              style={{
                display: this.state.showError == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Data not found for the dates specified.</p>
            </Message>
          </div>

          <div className="scrap-report">
            <div className="scrap-report__print">
              <ReactToPrint
                trigger={() => <a href="#">Print this out!</a>}
                content={() => this.componentRef}
              />
            </div>

            <GeneralLedgerEntryPrintReport
              transactions={transactions}
              totalDebit={totalDebit}
              totalCredit={totalCredit}
              totalReceivable={totalReceivable}
              closingTotalReceivable={closingTotalReceivable}
              closingTotalIncome={closingTotalIncome}
              closingTotalExpense={closingTotalExpense}
              closingTotalNetAmount={closingTotalNetAmount}
              totalPayable={totalPayable}
              totalIncome={totalIncome}
              totalExpense={totalExpense}
              netAmount={netAmount}
              ref={(el) => (this.componentRef = el)}
            />

            {/* <Table celled fixed singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={2}>Date</Table.HeaderCell>
                  <Table.HeaderCell width={6}>Description</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Type</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Debit</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Credit</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Balance</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {transactions.map(transaction => (
                  <Table.Row>
                    <Table.Cell>{transaction.date}</Table.Cell>
                    <Table.Cell>{transaction.description}</Table.Cell>
                    <Table.Cell>{transaction.type}</Table.Cell>
                    <Table.Cell>
                      {transaction.transaction === "Debit"
                        ? transaction.total
                        : 0}
                    </Table.Cell>
                    <Table.Cell>
                      {" "}
                      {transaction.transaction === "Credit"
                        ? transaction.total
                        : 0}
                    </Table.Cell>
                    <Table.Cell>{transaction.balance}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table> */}
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default GeneralLedgerReport;
